export default __webpack_public_path__ + "static/media/new_interpretazione_avanzata.770b04cc.jpeg";